// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Icons&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("http://localhost:3000/skins/mini.css?12"); */
/* @import url("https://cdn.webix.com/pro/edge/skins/willow.css?12"); */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.artList .webix_template{
    padding-top: 20px;
  }
.artList .webix_list_item{
    border: 1px solid #ebebeb;
    border-radius: 5px;
    margin:15px;
    /* padding-top:20px; */
    /* padding: 10; */
    width: 85% !important;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);  
    background: #fafafa;
  }
  .artLeftMenuBtn {
    background: "#0b022d !important",
  }
  .artLeftMenuBtnx .font-button .webix_icon{
    color: #1d7;
    font-size:45px;  
    margin-left:-20px;  
    }
  .artLeftMenuBtn .webix_el_box{
    background: #0b022d !important;
  }
  .artRightMenuBtn .webix_icon_button .webix_icon{
    font-size: 40px;
    padding: 0px !important;
    vertical-align: top;
  }
  .artRightMenuBtn .webix_el_box{
    background: #0b022d !important;
    padding: 0px !important;
    vertical-align: middle;
  }
  .temPictFetch{
    padding: "0px !important";
    margin: "0px !important";
    height: "auto !important";
  }
  
  .temPictFetch .webix_template{
    padding: 0px !important;
    margin: 0px !important;
  }
  
  .artMyTemplate .webix_template{
    background: #0b022d !important;
  }
  .artMyTemplateTop .webix_template{
    background: #0b022d !important;
    vertical-align: bottom;
    /* padding: 0px; */
  }
  .artMyTemplateBottom .webix_template{
    background: #0b022d !important;
    vertical-align: top;
    padding: 0px;
  }
  .artMainPhoto .webix_template{
    background: #0b022d !important;
  }
 .artTemplateRight .webix_template{
    text-align: right !important;
  }  
  .webix_template .labelRight{
    text-align: right !important;
  }  
  .labelRight{
    text-align: right;
  }
  .mainphoto{
    background: #0b022d !important;
    border-radius: 25px;
    width: 42px;
    height: 42px;
    cursor: pointer;
  } 
   .artMainprofilephoto .webix_template{
    padding: 0px;
   }
   .artMainprofilephoto{
    background:transparent;
    vertical-align:bottom;
    padding: 0px;
    /* border-radius: 100%; */
    cursor: pointer;

}
  .mywin .webix_win_head {
    background: #fff !important; 
    color: #fff;
  }
  .mywin .webix_win_head>.webix_view>.webix_template {
    background: #657584 !important; 
    color: #fff;
  }
  .webix_um_badge_container .webix_um_status_badge {
    box-sizing: border-box;
    height: 24px;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .webix_um_status_badge {
    border-radius: 8px;
    padding: 0px 12px;
    font-size: 14px;
    font-weight: 500;
  }
  .webix_um_status_badge.webix_um_active {
    background-color: #d4ede5;
    color: #55cd97;
  }
  .webix_um_status_badge.webix_um_not_active {
    background-color: #ffdedb;
    color: #ff6455;
  }
  .webix_um_status_badge.webix_um_unknown {
    background-color: #e6e6e6;
    color: #555;
  }
  .artTemplate .webix_template{
    padding: 0px;
  }  
  .artLabelTemplateTemplate .webix_template{
    padding: 0px;
    margin: 0px;
  }
  #video-container {
    width: 640px;
    height: 480px;
    position: relative;
  }
  #video-containerx {
    /* width: 640px; */
    height: 480px;
    /* position: relative; */
  }

  .layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  #pose-video {
    transform: scaleX(-1);
  }

  .pose-result {
    font-size: 100px;
    text-align: right;
    padding: 20px 30px 0 0;
  }

  #pose-result-left {
    text-align: left;
  }
  .webix_warning .webix_button {
    background: #fe860e !important;
    color: #ffffff;
    border: 1px solid #feac5a;
  }
  .webix_warning .webix_button:hover {
    background-color: #fea041;
  }
  .webix_warning .webix_button:focus {
    background-color: #fe952c;
  }
  .webix_warning .webix_button:active {
    background-color: #fe952c;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
  }
  .webix_warning .webix_button:hover {
    background-color: #fea041;
  }
  .webix_warning .webix_button:focus {
    background-color: #fe952c;
  }
  .webix_warning .webix_button:active {
    background-color: #fe952c;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
  }
  .webix_warning .webix_button:hover {
    background-color: #fea041;
  }
  .webix_warning .webix_button:focus {
    background-color: #fe952c;
  }
  .webix_warning .webix_button:active {
    background-color: #fe952c;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
  }
  .webix_warning .webix_button .webix_icon,
  .webix_warning .webix_button .webix_img_btn_text,
  .webix_warning .webix_button .webix_icon_btn {
    color: #ffffff;
  }
  .webix_warning .webix_pressed .webix_button {
    background-color: #fe952c;
  }
 `, "",{"version":3,"sources":["webpack://./src/assets/webix/css/artStyle.css"],"names":[],"mappings":"AAEA,4DAA4D;AAC5D,uEAAuE;AACvE;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;IACI,iBAAiB;EACnB;AACF;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,oCAAoC;IACpC,mBAAmB;EACrB;EACA;IACE;EACF;EACA;IACE,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB;EACF;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,8BAA8B;EAChC;CACD;IACG,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;GACC;IACC,YAAY;GACb;GACA;IACC,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;IACzB,eAAe;;AAEnB;EACE;IACE,2BAA2B;IAC3B,WAAW;EACb;EACA;IACE,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,oDAAoD;EACtD;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,oDAAoD;EACtD;EACA;;;IAGE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Material+Icons&display=swap\");\n@import url(\"https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css\");\n/* @import url(\"http://localhost:3000/skins/mini.css?12\"); */\n/* @import url(\"https://cdn.webix.com/pro/edge/skins/willow.css?12\"); */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.artList .webix_template{\n    padding-top: 20px;\n  }\n.artList .webix_list_item{\n    border: 1px solid #ebebeb;\n    border-radius: 5px;\n    margin:15px;\n    /* padding-top:20px; */\n    /* padding: 10; */\n    width: 85% !important;\n    box-shadow: 0 0 10px rgba(0,0,0,0.2);  \n    background: #fafafa;\n  }\n  .artLeftMenuBtn {\n    background: \"#0b022d !important\",\n  }\n  .artLeftMenuBtnx .font-button .webix_icon{\n    color: #1d7;\n    font-size:45px;  \n    margin-left:-20px;  \n    }\n  .artLeftMenuBtn .webix_el_box{\n    background: #0b022d !important;\n  }\n  .artRightMenuBtn .webix_icon_button .webix_icon{\n    font-size: 40px;\n    padding: 0px !important;\n    vertical-align: top;\n  }\n  .artRightMenuBtn .webix_el_box{\n    background: #0b022d !important;\n    padding: 0px !important;\n    vertical-align: middle;\n  }\n  .temPictFetch{\n    padding: \"0px !important\";\n    margin: \"0px !important\";\n    height: \"auto !important\";\n  }\n  \n  .temPictFetch .webix_template{\n    padding: 0px !important;\n    margin: 0px !important;\n  }\n  \n  .artMyTemplate .webix_template{\n    background: #0b022d !important;\n  }\n  .artMyTemplateTop .webix_template{\n    background: #0b022d !important;\n    vertical-align: bottom;\n    /* padding: 0px; */\n  }\n  .artMyTemplateBottom .webix_template{\n    background: #0b022d !important;\n    vertical-align: top;\n    padding: 0px;\n  }\n  .artMainPhoto .webix_template{\n    background: #0b022d !important;\n  }\n .artTemplateRight .webix_template{\n    text-align: right !important;\n  }  \n  .webix_template .labelRight{\n    text-align: right !important;\n  }  \n  .labelRight{\n    text-align: right;\n  }\n  .mainphoto{\n    background: #0b022d !important;\n    border-radius: 25px;\n    width: 42px;\n    height: 42px;\n    cursor: pointer;\n  } \n   .artMainprofilephoto .webix_template{\n    padding: 0px;\n   }\n   .artMainprofilephoto{\n    background:transparent;\n    vertical-align:bottom;\n    padding: 0px;\n    /* border-radius: 100%; */\n    cursor: pointer;\n\n}\n  .mywin .webix_win_head {\n    background: #fff !important; \n    color: #fff;\n  }\n  .mywin .webix_win_head>.webix_view>.webix_template {\n    background: #657584 !important; \n    color: #fff;\n  }\n  .webix_um_badge_container .webix_um_status_badge {\n    box-sizing: border-box;\n    height: 24px;\n    line-height: 24px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .webix_um_status_badge {\n    border-radius: 8px;\n    padding: 0px 12px;\n    font-size: 14px;\n    font-weight: 500;\n  }\n  .webix_um_status_badge.webix_um_active {\n    background-color: #d4ede5;\n    color: #55cd97;\n  }\n  .webix_um_status_badge.webix_um_not_active {\n    background-color: #ffdedb;\n    color: #ff6455;\n  }\n  .webix_um_status_badge.webix_um_unknown {\n    background-color: #e6e6e6;\n    color: #555;\n  }\n  .artTemplate .webix_template{\n    padding: 0px;\n  }  \n  .artLabelTemplateTemplate .webix_template{\n    padding: 0px;\n    margin: 0px;\n  }\n  #video-container {\n    width: 640px;\n    height: 480px;\n    position: relative;\n  }\n  #video-containerx {\n    /* width: 640px; */\n    height: 480px;\n    /* position: relative; */\n  }\n\n  .layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  #pose-video {\n    transform: scaleX(-1);\n  }\n\n  .pose-result {\n    font-size: 100px;\n    text-align: right;\n    padding: 20px 30px 0 0;\n  }\n\n  #pose-result-left {\n    text-align: left;\n  }\n  .webix_warning .webix_button {\n    background: #fe860e !important;\n    color: #ffffff;\n    border: 1px solid #feac5a;\n  }\n  .webix_warning .webix_button:hover {\n    background-color: #fea041;\n  }\n  .webix_warning .webix_button:focus {\n    background-color: #fe952c;\n  }\n  .webix_warning .webix_button:active {\n    background-color: #fe952c;\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);\n  }\n  .webix_warning .webix_button:hover {\n    background-color: #fea041;\n  }\n  .webix_warning .webix_button:focus {\n    background-color: #fe952c;\n  }\n  .webix_warning .webix_button:active {\n    background-color: #fe952c;\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);\n  }\n  .webix_warning .webix_button:hover {\n    background-color: #fea041;\n  }\n  .webix_warning .webix_button:focus {\n    background-color: #fe952c;\n  }\n  .webix_warning .webix_button:active {\n    background-color: #fe952c;\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);\n  }\n  .webix_warning .webix_button .webix_icon,\n  .webix_warning .webix_button .webix_img_btn_text,\n  .webix_warning .webix_button .webix_icon_btn {\n    color: #ffffff;\n  }\n  .webix_warning .webix_pressed .webix_button {\n    background-color: #fe952c;\n  }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
